// NetworkTopologies.js
import React, { useState } from "react";

const NetworkTopologies = () => {
  const [selectedTopology, setSelectedTopology] = useState("bus");

  const topologies = {
    bus: {
      name: "Bus-Topologie",
      description:
        " In einer Bus-Topologie sind alle Geräte über ein gemeinsames Übertragungsmedium (Bus), (z. B. ein Kabel) miteinander verbunden. Die Daten werden in beide Richtungen entlang des Bus gesendet und von allen Geräten empfangen. Aber nur das Gerät, das die richtigen Daten empfängt, verarbeitet sie weiter. Der Hauptvorteil dieser Topologie liegt in ihrer Einfachheit und den geringen Kosten. Allerdings kann der Ausfall des Hauptkabels das gesamte Netzwerk lahmlegen. Durch die begrenzte Skalierbarkeit kann es bei starkem Datenverkehr zu Kollisionen kommen.",
      image: "/images/bus.webp",
    },
    star: {
      name: "Stern-Topologie",
      description:
        "In einer Stern-Topologie ist jedes Gerät direkt mit einem zentralen Knotenpunkt, oft ein Switch oder Hub, verbunden. Dieser Knotenpunkt steuert den gesamten Datenverkehr im Netzwerk. Diese Topologie ist weit verbreitet, da sie einfach zu implementieren und zu verwalten ist. Sie bietet den Vorteil, dass bei dem Ausfall eines Endgeräts das restliche Netzwerk ungestört weiterarbeitet. Allerdings legt ein Ausfall des zentralen Geräts das gesamte Netzwerk lahm.",
      image: "/images/stern.webp",
    },
    ring: {
      name: "Ring-Topologie",
      description:
        "In einer Ring-Topologie ist jedes Gerät mit genau zwei anderen Geräten verbunden, wodurch ein geschlossener Kreis entsteht. Daten werden in eine Richtung im Kreis gesendet, von Gerät zu Gerät, bis sie ihr Ziel erreichen. Der Vorteil dieser Topologie ist, dass sie eine gleichmäßige Verteilung des Datenverkehrs ermöglicht. Allerdings kann ein Ausfall eines einzigen Geräts den gesamten Datenfluss unterbrechen.",
      image: "/images/ring.webp",
    },
    mesh: {
      name: "Mesh-Topologie",
      description:
        "In dieser fortschrittlichen Topologie ist jedes Gerät mit mehreren anderen Geräten verbunden, was eine hohe Redundanz und Ausfallsicherheit bietet. Wenn ein Weg für die Datenübertragung blockiert ist, kann das Netzwerk automatisch einen alternativen Pfad wählen. Diese Topologie ist sehr robust, aber aufgrund des komplexen Aufbaus und der höheren Kosten in der Implementierung auf größere Netzwerke beschränkt.",
      image: "/images/mesh.webp",
    },
    hybrid: {
      name: "Hybrid-Topologie",
      description:
        "Hybrid-Topologien kombinieren zwei oder mehr der anderen genannten Topologien, um die Vorteile verschiedener Ansätze zu nutzen. Ein Beispiel wäre ein Netzwerk, das eine Stern-Topologie für die Verbindung von Geräten in einem Bürogebäude verwendet, während die Büros selbst in einer Bus-Topologie miteinander verbunden sind.",
      image: "/images/hybrid.webp",
    },
  };

  return (
    <div className="container m-5">
      <div className="row">
        <div className="col-md-12">
          {Object.keys(topologies).map((topology) => (
            <button
              key={topology}
              className={`btn btn-outline-primary btn-block mx-auto me-4 mb-3 ${
                selectedTopology === topology ? "active" : ""
              }`}
              onClick={() => setSelectedTopology(topology)}
            >
              {topologies[topology].name}
            </button>
          ))}
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-8 p-5">
              <h4>{topologies[selectedTopology].name}</h4>
              <p>{topologies[selectedTopology].description}</p>
            </div>
            <div className="col-md-4 p-3">
              <img
                src={topologies[selectedTopology].image}
                alt={topologies[selectedTopology].name}
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkTopologies;
